import {createReducer} from "typesafe-actions";
import {SELECT_SPORT_MENU} from "../actions";

export const selectedSportMenu = createReducer<number | 'rating' | 'home' | null>('home')
    .handleAction(SELECT_SPORT_MENU, (state, action) => action.payload);